/* eslint-disable react/jsx-no-target-blank */
import React, { useRef, useEffect, useState } from "react";
import "./form.css";
import { useStateValue } from "./StateProvider";
import { useHistory } from "react-router";
import { postFormData, postGetData } from "../functions/form";
import Button from "@material-ui/core/Button";
import isEmpty from "validator/lib/isEmpty";

const divStyle = {
  marginTop: "67px",
  marginBottom: "67px",
};

function Form() {
  const [{ name, place, city, user }, dispatch] = useStateValue();
  const history = useHistory();
  const canteenname = useRef(null);
  const state = useRef(null);
  const price = useRef(null);
  const [canteenlink, setCanteenLink] = useState("");
  const phoneNumber = useRef(null);
  const token = user ? user.token : "";

  useEffect(() => {
    setCanteenLink(
      `https://www.google.com/maps/search/?api=1&query=${name}+${place}+${city}`
    );
  }, [name, place, city]);

  const submitted = (e) => {
    e.preventDefault();

    if (
      isEmpty(canteenname.current.value) ||
      isEmpty(state.current.value) ||
      isEmpty(price.current.value) ||
      isEmpty(phoneNumber.current.value)
    ) {
      alert("All fields are required.");
      return;
    } else {
      const details = {
        canteenname: canteenname.current.value,
        state: state.current.value,
        price: price.current.value,
        canteenlink,
        phoneNumber: phoneNumber.current.value,
      };
      //sending data to backend
      postFormData(details, token).then(() =>
        postGetData().then((res) => {
          //dispatching in reducer

          dispatch({
            type: "SET_DISPLAY",
            display: res.data.form,
          });
        })
      );

      history.push("/Search");
    }
  };
  return (
    <div style={divStyle}>
      <div className="form-style-6">
        <h1>Confirm Your Canteen Details </h1>
        <form onSubmit={submitted}>
          <input
            type="text"
            name="field1"
            ref={canteenname}
            placeholder="Canteen Name"
          />
          <input
            type="text"
            name="field2"
            ref={state}
            placeholder="City and State"
          />
          <input
            type="text"
            name="field2"
            ref={price}
            placeholder="Canteen price"
          />

          <label htmlFor="canteenlink">Canteen Link</label>
          <input
            id="canteenlink"
            type="text"
            value={canteenlink}
            onChange={(e) => setCanteenLink(e.target.value)}
            name="field2"
          />
          <Button>
            <a href={canteenlink} target="_blank">
              Go to Link
            </a>{" "}
          </Button>

          <label htmlFor="canteenlink">Contact Number</label>
          <input
            type="text"
            ref={phoneNumber}
            name="field2"
            placeholder="Contact Number"
          />
          {/* <textarea name="field3" ref={desc} placeholder="Description"></textarea> */}
          <input type="submit" value="Submit" onClick={submitted} />
        </form>
      </div>
    </div>
  );
}

export default Form;
